import axios from 'axios';

const API_URL = '/api/departments';

export const getDepartments = async () => {
  const { data } = await axios.get(API_URL);
  return data;
};

export const addDepartment = async (name) => {
  const { data } = await axios.post(API_URL, { name });
  return data;
};

export const updateDepartment = async (id, name) => {
  const { data } = await axios.put(`${API_URL}/${id}`, { name });
  return data;
};

export const deleteDepartment = async (id) => {
  const { data } = await axios.delete(`${API_URL}/${id}`);
  return data;
};
